import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';
import type { FlashSalesConfig } from '@/app/components/search/components/Card/types.ts';

const createCounterTranslations = (t: TranslationFunction) => ({
  d: t('vacation.oss.cards.flash_sales_d'),
  h: t('vacation.oss.cards.flash_sales_h'),
  m: t('vacation.oss.cards.flash_sales_m'),
  s: t('vacation.oss.cards.flash_sales_s'),
  days: t('vacation.oss.cards.flash_sales_d'),
  hrs: t('vacation.oss.cards.flash_sales_h'),
  mins: t('vacation.oss.cards.flash_sales_m'),
  secs: t('vacation.oss.cards.flash_sales_s'),
  day: t('vacation.oss.cards.flash_sales_d'),
});

export const createFlashSalesConfig = (dealCard: DealCard, t: TranslationFunction): FlashSalesConfig =>
  dealCard?.product?.promotions?.flashSale
    ? createFlashSalesConfigByExpirationDate(dealCard?.product?.promotions?.flashSaleExpiration, t)
    : null;

export const createFlashSalesConfigByExpirationDate = (expirationDate: string | undefined, t: TranslationFunction) =>
  expirationDate
    ? {
        isActive: true,
        expiration: expirationDate,
        expirationLabel: t('vacation.oss.cards.flash_sales_expiration_label'),
        expiredLabel: t('vacation.oss.cards.flash_sales_expired_label'),
        counterTranslations: createCounterTranslations(t),
      }
    : null;

/** An expiration the browser cannot parse yields an Invalid Date, and there is no countdown to show */
export const isParseable = (expirationDate: Date) => !Number.isNaN(expirationDate.getTime());

export const getExpirationDate = (expiration: string) => {
  const expirationDate = new Date(expiration);
  expirationDate.setHours(23);
  expirationDate.setMinutes(59);
  expirationDate.setSeconds(59);
  return expirationDate;
};
